/** Stable preference ids, forwarded to the chat API as reasoning_effort. */

export const THINKING_LEVELS = [
  { id: 'off', label: 'Off', hint: 'No extra reasoning budget' },
  { id: 'minimal', label: 'Minimal', hint: 'The smallest reasoning budget' },
  { id: 'low', label: 'Light', hint: 'Quick pass' },
  { id: 'standard', label: 'Balanced', hint: 'Balanced' },
  { id: 'high', label: 'Deep', hint: 'More time for harder questions' },
  { id: 'xhigh', label: 'Extra high', hint: 'The most room to think' },
  { id: 'max', label: 'Maximum', hint: 'The highest available effort' },
];

export const DEFAULT_THINKING = 'standard';

export function thinkingSystemHint(level) {
  switch (level) {
    case 'off':
      return '';
    case 'low':
      return 'Prefer brief, direct answers with minimal deliberation.';
    case 'high':
      return 'Think carefully before answering. Prefer thorough reasoning when helpful.';
    case 'standard':
    default:
      return '';
  }
}
